import PrimeVue from "primevue/config";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import Dropdown from "primevue/dropdown";
import { useToast } from "primevue/usetoast";

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.use(PrimeVue, { ripple: false });
	nuxtApp.vueApp.component("Button", Button);
	nuxtApp.vueApp.component("Dropdown", Dropdown);
	nuxtApp.vueApp.component("InputText", InputText);
	nuxtApp.vueApp.use(ToastService);
	nuxtApp.vueApp.component("Toast", Toast);

	const toast = useToast();

	return {
		provide: {
			toast,
		},
	};
});
